<div class="flex justify-content-center my-5">
  <small>
    <a routerLink="/privacidade">Política de Privacidade</a>
 </small>
</div>
